export default "__VITE_ASSET__9f41347d__"